import * as React from 'react';
import './UpdateTeamMembers.css';
import OfflineInvestor from 'src/entities/OfflineInvestor';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';

export interface ProjectUpdateOfflineInvestorCardComponentProps {
  offlineInvestor: OfflineInvestor;
  formData: OfflineInvestor;
  editOfflineInvestor: () => void;
  edit: boolean;
  deleteOfflineInvestor: () => void;
  handleChange: (key: string) => (value: string | File) => void;
  handleSubmit: () => void;
  errorMessage: {};
}

class ProjectUpdateOfflineInvestorCardComponent
  extends React.Component<ProjectUpdateOfflineInvestorCardComponentProps> {

  public render(): React.ReactNode {

    return (
      <div className={this.props.edit ? 'col-md-12 col-sm-12' : 'col-md-6 col-sm-6'}>
        {this.props.edit ?
          <div className="simple-card">
            <div className="row">
              <div className="gap-20"/>
              <div className="col-sm-4 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Nombre"
                    type="text"
                    value={this.props.formData!.name || ''}
                    onChange={(value) => this.props.handleChange('name')(value)}
                    required={true}
                  />
                </div>
                <div className="gap-20"/>
              </div>
              <div className="col-sm-4 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Tipo de inversión"
                    type="text"
                    value={this.props.formData!.investmentType || ''}
                    onChange={(value) => this.props.handleChange('investmentType')(value)}
                    required={true}
                  />
                </div>
                <div className="gap-20"/>
              </div>
              <div className="col-sm-4 col-md-4">
                <div className="md-input">
                  <InputContainer
                    label="Importe"
                    type="number"
                    value={this.props.formData!.amountInvested.toString() || ''}
                    onChange={(value) => this.props.handleChange('amountInvested')(value)}
                    required={true}
                  />
                  <span className="euro-input icon-error-input"/>
                </div>
                <div className="text-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-container="body"
                    data-html="true"
                    data-toggle="popover"
                    data-placement="bottom"
                    onClick={(e) => this.props.handleSubmit()}
                  >
                    Guardar
                  </button>
                  <div className="gap-10"/>
                  <ErrorMessagesComponent
                    errorMessage={this.props.errorMessage}
                  />
                </div>
              </div>
            </div>
          </div>
          :
          <div className="simple-card offline-investor">
            <span
              className="close-med pointer"
              onClick={() => this.props.deleteOfflineInvestor()}
            />
            <p><strong>{this.props.offlineInvestor.name}</strong></p>
            <p>Tipo de inversión: {this.props.offlineInvestor.investmentType}</p>
            <p>Importe: {this.props.offlineInvestor.amountInvested.toLocaleString('es')} €</p>
            <button
              type="button"
              className="btn"
              data-container="body"
              data-html="true"
              data-toggle="popover"
              data-placement="bottom"
              onClick={(e) => this.props.editOfflineInvestor()}
            >
              Editar
            </button>
          </div>
        }
      </div>
    );
  }
}

export default ProjectUpdateOfflineInvestorCardComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectUpdateOfflineInvestorCard.component.tsx